/**
 * Sous-composants UI partages par les 4 onglets de SeancesPage.
 */
import { AlertCircle } from 'lucide-react'
import { T } from '../../theme'

export function SkeletonGrid({ count = 6, minWidth = 280 }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`,
      gap: 16,
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{
          background: T.surface, border: `2px solid ${T.dark}`,
          boxShadow: `4px 4px 0 ${T.dark}`,
          height: 320, position: 'relative', overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute', inset: 0,
            background: `linear-gradient(90deg, transparent, ${T.bgAlt} 40%, transparent 80%)`,
            animation: 'shimmer 1.6s infinite',
          }} />
          <style>{`@keyframes shimmer { from { transform: translateX(-100%); } to { transform: translateX(100%); } }`}</style>
        </div>
      ))}
    </div>
  )
}

export function ErrorState({ message, onRetry }) {
  return (
    <div style={{
      textAlign: 'center', padding: '40px 20px',
      background: T.redBg, border: `2px solid ${T.red}`,
    }}>
      <AlertCircle size={28} color={T.red} style={{ margin: '0 auto 10px', display: 'block' }} />
      <p style={{ fontFamily: T.mono, fontSize: 12, color: T.ink, marginBottom: 14 }}>
        {message}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            background: T.surface, color: T.ink, border: `2px solid ${T.dark}`,
            padding: '8px 16px', cursor: 'pointer',
            fontFamily: T.mono, fontSize: 10, fontWeight: 700,
            letterSpacing: '.12em', textTransform: 'uppercase',
          }}
        >
          Réessayer
        </button>
      )}
    </div>
  )
}

export function EmptyState({ title, message, ctaLabel, onCta, icon = null }) {
  return (
    <div style={{
      textAlign: 'center', padding: '60px 20px',
      background: T.surface, border: `2px dashed ${T.rule}`,
    }}>
      {icon && <div style={{ marginBottom: 12 }}>{icon}</div>}
      <div style={{
        fontFamily: T.display, fontSize: 22, color: T.ink,
        textTransform: 'uppercase', marginBottom: 8,
      }}>
        {title}
      </div>
      {message && (
        <p style={{
          fontFamily: T.mono, fontSize: 11, color: T.muted2,
          marginBottom: 18, maxWidth: 480, margin: '0 auto 18px',
        }}>
          {message}
        </p>
      )}
      {ctaLabel && onCta && (
        <button
          type="button"
          onClick={onCta}
          style={{
            background: T.gold, color: T.dark, border: `2px solid ${T.dark}`,
            boxShadow: `4px 4px 0 ${T.dark}`,
            padding: '10px 18px', cursor: 'pointer',
            fontFamily: T.mono, fontSize: 11, fontWeight: 700,
            letterSpacing: '.14em', textTransform: 'uppercase',
          }}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  )
}

export function btnPrimary({ disabled = false } = {}) {
  return {
    background: T.gold, color: T.dark, border: `2px solid ${T.dark}`,
    boxShadow: `4px 4px 0 ${T.dark}`,
    padding: '10px 16px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    fontFamily: T.mono, fontSize: 11, fontWeight: 700,
    letterSpacing: '.14em', textTransform: 'uppercase',
    display: 'inline-flex', alignItems: 'center', gap: 6,
  }
}

export function btnGhost({ disabled = false, danger = false } = {}) {
  return {
    background: T.surface,
    color: danger ? T.red : T.ink,
    border: `2px solid ${danger ? T.red : T.dark}`,
    padding: '8px 12px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    fontFamily: T.mono, fontSize: 10, fontWeight: 700,
    letterSpacing: '.12em', textTransform: 'uppercase',
    display: 'inline-flex', alignItems: 'center', gap: 6,
  }
}
